import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const TagList = styled.ul`
  display: flex;
  flex-direction: row;
  align-content: flex-start; 
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  max-height: 4rem;
  overflow: hidden;
    
  ${({ theme }) => theme.mq.lg`
    padding: 0;
    max-height: 2rem;
  `};
`;

const TagItem = styled.li`
  list-style-type: none;
  margin: 0 .5rem .5rem 0;
  padding: 0;
`;  

const TagText = styled.span`
  background-color:  ${({ theme }) => theme.themeColors.light};
  color: ${({ theme }) => theme.themeColors.darkGreen4};
  font-size: .875rem;
  font-weight: 500;
  margin: 0 0 .5rem;
  padding: .5rem .5rem .25rem;
`;

function Tags({data}) {
  return (
    <TagList>
        {data.map((item) => {
          const {attributes} = item;
          const {title} = attributes;
          return (
            <TagItem key={title}>
              <TagText>{title}</TagText>
            </TagItem>
            );
        })}
      </TagList>
  );
}

export default Tags;

Tags.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
};

Tags.defaultProps = {
  data: [],
};
